import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React from 'react';
import { Field, useField } from 'react-final-form';
import styled from 'styled-components';
import { IQuestion } from '../../types';
import { showErrorOnChange } from '../../utils/radioErrors';

interface IProps {
  question: IQuestion;
}

const RadioQuestion = ({ question }: IProps) => {
  const field = useField(`${question.id}`);
  const hasError = showErrorOnChange(field);
  const required = (value: string) => (value ? undefined : 'Required');

  return (
    <StyledGrid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
    >
      <>
        <QuestionContainer>{question.title}</QuestionContainer>
        <StyledFormControl error={hasError} variant="outlined">
          <RadioGroup row aria-label={question.id}>
            {question.alternatives?.map((alternative) => {
              return (
                <FormControlLabel
                  key={`radio-${alternative}`}
                  value={alternative}
                  control={
                    <Field
                      name={`${question.id}`}
                      type="radio"
                      initialValue=""
                      validate={required}
                    >
                      {({
                        input: { name, value, onChange, checked, ...restInput },
                      }) => {
                        return (
                          <>
                            <Radio
                              name={name}
                              value={value}
                              onChange={onChange}
                              checked={checked}
                              inputProps={{
                                ...restInput,
                                'aria-label': `radio-${value}`,
                              }}
                            />
                          </>
                        );
                      }}
                    </Field>
                  }
                  label={alternative}
                />
              );
            })}
          </RadioGroup>
          {hasError && (
            <FormHelperText>
              {field.meta.error || field.meta.submitError}
            </FormHelperText>
          )}
        </StyledFormControl>
      </>
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)`
  margin-bottom: 30px;
`;

const QuestionContainer = styled('div')`
  width: 293px;
  font-family: EB Garamond;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;

const StyledFormControl = styled(FormControl)`
  width: 220px;
  height: 56px;
  margin-left: 62px;
`;

export default RadioQuestion;
